import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './components/auth/auth.component';
import { LoginComponent } from './components/auth/login/login.component';
import { OauthCallbackComponent } from './components/auth/oauth-callback/oauth-callback.component';
import { RestorePasswordComponent } from './components/auth/restore-password/restore-password.component';
import { ConfigurationComponent } from './components/main/employees/direction/configuration/configuration.component';
import { DashboardComponent } from './components/main/employees/dashboard/dashboard.component';
import { LegalDocumentationComponent } from './components/main/employees/direction/legal-documentation/legal-documentation.component';
import { MainComponent } from './components/main/main.component';
import { CompanyProductDetailComponent } from './components/main/shared/company-products/company-product-detail/company-product-detail.component';
import { CompanyProductsComponent } from './components/main/shared/company-products/company-products.component';
import { SupportComponent } from './components/main/employees/support/support.component';
import { UsersDetailComponent } from './components/main/employees/direction/users/users-detail-tabs/users-detail/users-detail.component';
import { UsersComponent } from './components/main/employees/direction/users/users.component';
import { LoggedGuard } from './guards/logged.guard';
import { RegexServiceInitiatedGuard } from './guards/regex-service-initiated.guard';
import { CompaniesComponent } from './components/main/employees/direction/companies/companies.component';
import { CompanyDetailComponent } from './components/main/employees/direction/companies/company-detail/company-detail.component';
import { ProvidersComponent } from './components/main/employees/direction/providers/providers.component';
import { ProviderDetailComponent } from './components/main/employees/direction/providers/provider-detail/provider-detail.component';
import { MessagingConversationsComponent } from './components/main/employees/direction/configuration/messaging-conversations/messaging-conversations.component';
import { MessagingWorkspacesComponent } from './components/main/employees/direction/configuration/messaging-workspaces/messaging-workspaces.component';
import { WorkingTimesHistoryComponent } from './components/main/employees/activity/working-times-history/working-times-history.component';
import { WorkingTimesCalendarComponent } from './components/main/employees/activity/working-times-calendar/working-times-calendar.component';
import { BlogpostsComponent } from './components/main/employees/marketing/blogposts/blogposts.component';
import { ClockRegistersComponent } from './components/main/employees/activity/clock-registers/clock-registers.component';
import { VacationsComponent } from './components/main/employees/rrhh/absences-management/vacations/vacations.component';
import { TicketsComponent } from './components/main/employees/support/tickets/tickets.component';
import { MyAbsencesComponent } from './components/main/employees/personal/my-absences/my-absences.component';
import { MyPayrollsComponent } from './components/main/employees/performance/my-payrolls/my-payrolls.component';
import { MyRemunerationComponent } from './components/main/employees/performance/my-payrolls/my-remuneration/my-remuneration.component';
import { MyPayrollsListComponent } from './components/main/employees/performance/my-payrolls/my-payrolls-list/my-payrolls-list.component';
import { CompanyProductManagementComponent } from './components/main/employees/product-management/product-management.component';
import { MarketingComponent } from './components/main/employees/marketing/marketing.component';
import { RrhhComponent } from './components/main/employees/rrhh/rrhh.component';
import { DirectionComponent } from './components/main/employees/direction/direction.component';
import { ProductionComponent } from './components/main/employees/production/production.component';
import { ProductionKpiMatrixComponent } from './components/main/employees/production/production-kpi-matrix/production-kpi-matrix.component';
import { ProductionTeamGuard } from './guards/roles/production_team.guard';
import { MarketingGuard } from './guards/roles/marketing.guard';
import { RrhhGuard } from './guards/roles/rrhh.guard';
import { RrhhExtraHoursGuard } from './guards/roles/rrhh-extra-hours.guard';
import { RrhhRemoteWorkGuard } from './guards/roles/rrhh-remote-work.guard';
import { DirectionGuard } from './guards/roles/direction.guard';
import { CompanyProductBillingAccessGuard } from './guards/company-product-billing-access.guard';
import { CompanyProductAccountManagerAccessGuard } from './guards/company-product-account-manager-access.guard';
import { AbsencesManagementComponent } from './components/main/employees/rrhh/absences-management/absences-management.component';
import { PayrollsComponent } from './components/main/employees/rrhh/payrolls/payrolls.component';
import { DepartmentsInitiatedGuard } from './guards/departments-initiated.guard';
import { SupportGuard } from './guards/roles/support.guard';
import { CompanyProductOkrAndMetricsComponent } from './components/main/shared/company-products/company-product-detail/company-product-okr-and-metrics/company-product-okr-and-metrics.component';
import { ClockRegisterReviewRequestsComponent } from './components/main/employees/rrhh/clock-register-review-requests/clock-register-review-requests.component';
import { WorkingContractWeeklyScheduleExceptionRequestsComponent } from './components/main/employees/rrhh/working-contract-weekly-schedule-exception-requests/working-contract-weekly-schedule-exception-requests.component';
import { DepartmentsComponent } from './components/main/employees/rrhh/departments/departments.component';
import { DepartmentDetailComponent } from './components/main/employees/rrhh/departments/department-detail/department-detail.component';
import { DepartmentCategoryDetailComponent } from './components/main/employees/rrhh/departments/department-detail/department-category-detail/department-category-detail.component';
import { EmployeeGuard } from './guards/employee.guard';
import { ForceDesktopAppGuard } from './guards/force-desktop-app.guard';
import { WorkerGuard } from './guards/worker.guard';
import { UseDesktopAppComponent } from './components/main/employees/use-desktop-app/use-desktop-app.component';
import { ClientsGuard } from './guards/clients.guard';
import { CompanyProductPhasesComponent } from './components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phases.component';
import { CompanyProductPhasesDetailComponent } from './components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-detail.component';
import { CompanyProductPhaseBacklogComponent } from './components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-backlog/company-product-phase-backlog.component';
import { CompanyProductPhaseBoardsComponent } from './components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-boards/company-product-phase-boards.component';
import { ComercialComponent } from './components/main/employees/comercial/comercial.component';
import { ComercialGuard } from './guards/roles/comercial.guard';
import { PotentialClientsComponent } from './components/main/employees/comercial/potential-clients/potential-clients.component';
import { PotentialClientDetailComponent } from './components/main/employees/comercial/potential-clients/potential-client-detail/potential-client-detail.component';
import { PotentialClientMeetingRecordComponent } from './components/main/employees/comercial/potential-clients/potential-client-detail/potential-client-meeting-record/potential-client-meeting-record.component';
import { CommercialDashboardComponent } from './components/main/employees/comercial/commercial-dashboard/commercial-dashboard.component';
import { LeadAssignmentComponent } from './components/main/employees/comercial/lead-assignment/lead-assignment.component';
import { WikiComponent } from './components/main/employees/wiki/wiki.component';
import { WikiNodeComponent } from './components/main/employees/wiki/wiki-node/wiki-node.component';
import { WikiArticleComponent } from './components/main/employees/wiki/wiki-article/wiki-article.component';
import { CompanyProductMeetingRecordsComponent } from './components/main/shared/company-products/company-product-detail/company-product-meeting-records/company-product-meeting-records.component';
import { CompanyProductMeetingRecordCreditComponent } from './components/main/shared/company-products/company-product-detail/company-product-meeting-records/company-product-meeting-record-credit/company-product-meeting-record-credit.component';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { CompanyProductApplicationsComponent } from './components/main/shared/company-products/company-product-detail/company-product-applications/company-product-applications.component';
import { CompanyProductApplicationCreditComponent } from './components/main/shared/company-products/company-product-detail/company-product-applications/company-product-application-credit/company-product-application-credit.component';
import { HolidaysComponent } from './components/main/employees/rrhh/holidays/holidays.component';
import { AllLocationsManagementComponent } from './components/main/employees/rrhh/all-locations-management/all-locations-management.component';
import { ProjectLocationsComponent } from './components/main/shared/projects/project-detail/project-locations/project-locations.component';
import { CompanyProductGuardianScheduledWeeksComponent } from './components/main/shared/company-products/company-product-detail/company-product-guardian-scheduled-weeks/company-product-guardian-scheduled-weeks.component';
import { CompanyProductDeploysComponent } from './components/main/shared/company-products/company-product-detail/company-product-deploys/company-product-deploys.component';
import { CompanyProductDeployDetailComponent } from './components/main/shared/company-products/company-product-detail/company-product-deploy-detail/company-product-deploy-detail.component';
import { CompanyProductTeamsComponent } from './components/main/shared/company-products/company-product-detail/company-product-teams/company-product-teams.component';
import { CompanyProductCommunicationComponent } from './components/main/shared/company-products/company-product-detail/company-product-communication/company-product-communication.component';
import { CompanyProductStatusMonitorsComponent } from './components/main/shared/company-products/company-product-detail/company-product-status-monitors/company-product-status-monitors.component';
import { MyCareerPlanComponent } from './components/main/employees/performance/my-career-plan/my-career-plan.component';
import { ComputersComponent } from './components/main/employees/rrhh/computers/computers.component';
import { BisualSettingInitializedGuard } from './guards/bisual-setting-initialized.guard';
import { MyCompanyProductRolesInitiatedGuard } from './guards/my-company-product-roles-initiated.guard';
import { MustBeMemberOfCompanyProductGuard } from './guards/must-be-member-of-company-product.guard';
import { OkrManagementAccessGuard } from './guards/okr-management-access.guard';
import { MyVacationsComponent } from './components/main/employees/personal/my-absences/my-vacations/my-vacations.component';
import { LocalHolidaysComponent } from './components/main/employees/personal/my-absences/local-holidays/local-holidays.component';
import { UsersDetailTabsComponent } from './components/main/employees/direction/users/users-detail-tabs/users-detail-tabs.component';
import { UserMeetingRecordsComponent } from './components/main/employees/direction/users/users-detail-tabs/user-meeting-records/user-meeting-records.component';
import { CreditUserMeetingRecordComponent } from './components/main/employees/direction/users/users-detail-tabs/user-meeting-records/credit-user-meeting-record/credit-user-meeting-record.component';
import { RemoteWorkManagementComponent } from './components/main/employees/rrhh/remote-work-management/remote-work-management.component';
import { PartnerGuard } from './guards/partner.guard';
import { CompanyProductPhaseBoardDetailComponent } from './components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-boards/company-product-phase-board-detail/company-product-phase-board-detail.component';
import { WorkersComponent } from './components/main/employees/rrhh/workers/workers.component';
import { UserDocumentsListComponent } from './components/main/employees/rrhh/user-documents-list/user-documents-list.component';
import { CareerPlansListComponent } from './components/main/employees/direction/users/users-detail-tabs/career-plans-list/career-plans-list.component';
import { PartnerContractsListComponent } from './components/main/employees/direction/users/users-detail-tabs/partner-contracts-list/partner-contracts-list.component';
import { DocumentTypesListComponent } from './components/main/employees/rrhh/document-types-list/document-types-list.component';
import { LearningResourceRequestsListComponent } from './components/main/employees/rrhh/learning-resource-requests-list/learning-resource-requests-list.component';
import { SurveyEditComponent } from 'src/app/components/main/employees/rrhh/survey-edit/survey-edit.component';
import { SurveySectionEditComponent } from 'src/app/components/main/employees/rrhh/survey-edit/survey-section-edit/survey-section-edit.component';
import { SurveysListComponent } from 'src/app/components/main/employees/rrhh/surveys-list/surveys-list.component';
import { FormationsByUserDetailComponent } from './components/main/employees/rrhh/formations-management/formations-by-user-detail/formations-by-user-detail.component';
import { FormationsByUserTabComponent } from './components/main/employees/rrhh/formations-management/formations-by-user-tab/formations-by-user-tab.component';
import { FormationsCatalogTabComponent } from './components/main/employees/rrhh/formations-management/formations-catalog-tab/formations-catalog-tab.component';
import { FormationsManagementComponent } from './components/main/employees/rrhh/formations-management/formations-management.component';
import { ExamInstanceDetailComponent } from './components/main/employees/rrhh/exam-instance-detail/exam-instance-detail.component';
import { ExamInstanceEvaluationDetailComponent } from './components/main/employees/rrhh/exam-instance-evaluation-detail/exam-instance-evaluation-detail.component';
import { ExamInstancesListComponent } from './components/main/employees/rrhh/exam-instances-list/exam-instances-list.component';
import { ExamTemplatesListComponent } from './components/main/employees/rrhh/exam-templates-list/exam-templates-list.component';
import { JobDescriptionTemplatesListComponent } from './components/main/employees/rrhh/job-description-templates-list/job-description-templates-list.component';
import { SkillQuestionDetailComponent } from './components/main/employees/rrhh/skill-question-detail/skill-question-detail.component';
import { SkillQuestionsListComponent } from './components/main/employees/rrhh/skill-questions-list/skill-questions-list.component';
import { SkillsListComponent } from 'src/app/components/main/employees/rrhh/skills-list/skills-list.component';
import { SkillCategoriesListComponent } from 'src/app/components/main/employees/rrhh/skill-categories-list/skill-categories-list.component';
import { JobVacanciesListComponent } from './components/main/employees/rrhh/job-vacancies-list/job-vacancies-list.component';
import { JobCandidateDetailComponent } from './components/main/employees/rrhh/job-vacancy-candidate-detail/job-vacancy-candidate-detail.component';
import { JobCandidateMeetingRecordDetailComponent } from './components/main/employees/rrhh/job-vacancy-candidate-meeting-record-detail/job-vacancy-candidate-meeting-record-detail.component';
import { JobVacancyDetailComponent } from './components/main/employees/rrhh/job-vacancy-detail/job-vacancy-detail.component';
import { ProductionPlanificationComponent } from './components/main/employees/product-management/production-planification/production-planification.component';
import { AbsenceRequestsComponent } from './components/main/employees/personal/my-absences/absence-requests/absence-requests.component';
import { MyAbsenceRequestsDetailComponent } from './components/main/employees/personal/my-absences/absence-requests/my-absence-requests-detail/my-absence-requests-detail.component';
import { MyMetricsComponent } from './components/main/employees/performance/my-metrics/my-metrics.component';
import { AssistedMeetingRecordsComponent } from './components/main/employees/activity/assisted-meeting-records/assisted-meeting-records.component';
import { MediaRecordingDiarizationPageComponent } from './components/main/shared/meeting-record/media-recording-diarization-page/media-recording-diarization-page.component';
import { MyWorkingExtraHoursPeriodsComponent } from './components/main/employees/personal/my-working-extra-hours-periods/my-working-extra-hours-periods.component';
import { MyDrivingRequestsComponent } from './components/main/employees/my-zone/my-driving-requests/my-driving-requests.component';
import { UpskillingComponent } from './components/main/employees/performance/upskilling/upskilling.component';
import { UpskillingFormationsTabComponent } from './components/main/employees/performance/upskilling/upskilling-formations-tab/upskilling-formations-tab.component';
import { UpskillingCatalogTabComponent } from './components/main/employees/performance/upskilling/upskilling-catalog-tab/upskilling-catalog-tab.component';
import { UpskillingSkillsTabComponent } from './components/main/employees/performance/upskilling/upskilling-skills-tab/upskilling-skills-tab.component';
import { UpskillingExamsTabComponent } from './components/main/employees/performance/upskilling/upskilling-exams-tab/upskilling-exams-tab.component';
import { WorkingExtraHoursPeriodsManagementComponent } from './components/main/employees/rrhh/working-extra-hours-periods-management/working-extra-hours-periods-management.component';
import { DrivingRequestsManagementComponent } from './components/main/employees/rrhh/driving-requests-management/driving-requests-management.component';
import { CompanyProductBillingPeriodsComponent } from './components/main/shared/company-products/company-product-billing-periods/company-product-billing-periods.component';
import { CompanyProductMonthlyEconomicReportConciliationComponent } from './components/main/shared/company-products/company-product-monthly-economic-report-conciliation/company-product-monthly-economic-report-conciliation.component';
import { CompanyProductMonthlyEconomicReportDetailComponent } from './components/main/shared/company-products/company-product-monthly-economic-report-detail/company-product-monthly-economic-report-detail.component';
import { CompanyProductObjectivesComponent } from './components/main/shared/company-products/company-product-detail/company-product-objectives/company-product-objectives.component';
import { RrhhDrivingGuard } from './guards/roles/rrhh-driving.guard';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      { path: 'login', component: LoginComponent, title: 'Iniciar sesión' },
      { path: 'reset-password', component: RestorePasswordComponent, title: 'Restablecer contraseña' },
      { path: 'oauth/callback', component: OauthCallbackComponent, title: 'Completando inicio de sesión' },
      { path: '**', pathMatch: 'full', redirectTo: 'login' },
    ],
  },
  {
    path: '',
    canActivate: [LoggedGuard],
    component: MainComponent,
    children: [
      {
        path: 'employees',
        canActivate: [EmployeeGuard, BisualSettingInitializedGuard, MyCompanyProductRolesInitiatedGuard],
        canActivateChild: [ForceDesktopAppGuard],
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
          {
            path: 'use-desktop-app',
            component: UseDesktopAppComponent,
            title: 'Usa la app de escritorio',
          },
          { path: 'dashboard', component: DashboardComponent, title: 'Dashboard', canActivate: [WorkerGuard] },
          {
            path: 'meeting-records/:meeting_record_id/media-recordings/:media_recording_id/diarization',
            component: MediaRecordingDiarizationPageComponent,
            title: 'Diarización',
          },
          {
            path: 'my-profile',
            canActivate: [RegexServiceInitiatedGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'personal' },
              { path: ':section', component: UsersDetailComponent, title: 'Editar mi perfil' },
            ],
          },
          {
            path: 'activity',
            canActivate: [WorkerGuard],
            children: [
              { path: 'history', component: WorkingTimesHistoryComponent, title: 'Mi trabajo' },
              { path: 'assisted-meeting-records', component: AssistedMeetingRecordsComponent, title: 'Mis reuniones' },
              { path: 'calendar', component: WorkingTimesCalendarComponent, title: 'Calendario', canDeactivate: [PendingChangesGuard] },
              { path: 'clock-registers', component: ClockRegistersComponent, title: 'Fichar y registro horario' },
              { path: '**', pathMatch: 'full', redirectTo: 'history' },
            ],
          },
          {
            path: 'performance',
            children: [
              { path: 'metrics', component: MyMetricsComponent, title: 'Mis métricas' },
              { path: 'career-plan', component: MyCareerPlanComponent, title: 'Mi carrera' },
              {
                path: 'upskilling',
                component: UpskillingComponent,
                title: 'Upskilling',
                children: [
                  { path: '', redirectTo: 'catalog', pathMatch: 'full' },
                  {
                    path: 'catalog',
                    component: UpskillingCatalogTabComponent,
                    title: 'Upskilling — Catálogo',
                  },
                  {
                    path: 'history',
                    component: UpskillingFormationsTabComponent,
                    title: 'Upskilling — Mi historial',
                  },
                  {
                    path: 'skills',
                    component: UpskillingSkillsTabComponent,
                    title: 'Upskilling — Skills',
                  },
                  {
                    path: 'exams',
                    component: UpskillingExamsTabComponent,
                    title: 'Upskilling — Mis exámenes',
                  },
                  {
                    path: 'exams/:id/evaluations/:evaluation_id',
                    component: ExamInstanceEvaluationDetailComponent,
                    title: 'Upskilling — Evaluación',
                  },
                ],
              },
              {
                path: 'payrolls',
                component: MyPayrollsComponent,
                title: 'Mi retribución',
                children: [
                  { path: '', redirectTo: 'compensation', pathMatch: 'full' },
                  {
                    path: 'compensation',
                    component: MyRemunerationComponent,
                    title: 'Mi retribución',
                  },
                  {
                    path: 'payslips',
                    component: MyPayrollsListComponent,
                    title: 'Mis nóminas',
                  },
                ],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'metrics' },
            ],
          },
          {
            path: 'personal',
            children: [
              {
                path: 'working-extra-hours-periods',
                component: MyWorkingExtraHoursPeriodsComponent,
                title: 'Mis horas extras',
              },
              {
                path: 'absences',
                component: MyAbsencesComponent,
                children: [
                  { path: 'my-vacations', component: MyVacationsComponent, title: 'Mis vacaciones' },
                  { path: 'local-holidays', component: LocalHolidaysComponent, title: 'Festivos locales' },
                  {
                    path: 'my-absence-requests',
                    children: [
                      {
                        path: '',
                        component: AbsenceRequestsComponent,
                        title: 'Mis bajas y permisos',
                      },
                      {
                        path: 'create',
                        component: MyAbsenceRequestsDetailComponent,
                        title: 'Crear baja o permiso',
                        canDeactivate: [PendingChangesGuard],
                      },
                      {
                        path: ':id/modify',
                        component: MyAbsenceRequestsDetailComponent,
                        title: 'Solicitud de modificación de baja o permiso',
                        canDeactivate: [PendingChangesGuard],
                      },
                    ],
                  },
                  { path: '**', pathMatch: 'full', redirectTo: 'my-vacations' },
                ],
              },
              { path: 'my-documents', component: UserDocumentsListComponent, title: 'Mis documentos' },
              {
                path: 'remote-work-exceptions',
                component: RemoteWorkManagementComponent,
                title: 'Mis excepciones de teletrabajo',
              },
              { path: 'driving-requests', component: MyDrivingRequestsComponent, title: 'Viajes' },
              { path: '**', pathMatch: 'full', redirectTo: 'working-extra-hours-periods' },
            ],
          },
          {
            path: 'support',
            component: SupportComponent,
            canActivate: [DepartmentsInitiatedGuard, SupportGuard],
            title: 'Soporte',
            children: [
              { path: 'tickets', component: TicketsComponent, title: 'Tickets' },

              { path: '**', pathMatch: 'full', redirectTo: 'tickets' },
            ],
          },
          {
            path: 'development',
            component: CompanyProductManagementComponent,
            canActivate: [DepartmentsInitiatedGuard, ProductionTeamGuard],
            children: [
              {
                path: 'company-products/:company_product_id/phases/:phase_id',
                component: CompanyProductPhasesDetailComponent,
                canActivate: [MustBeMemberOfCompanyProductGuard],
                children: [
                  { path: 'backlog', component: CompanyProductPhaseBacklogComponent, title: 'Backlog de producto' },
                  { path: 'roadmap', component: CompanyProductPhaseBacklogComponent, title: 'Roadmap de producto' },
                  {
                    path: 'boards',
                    component: CompanyProductPhaseBoardsComponent,
                    title: 'Boards del producto',
                    children: [{ path: ':board_id', component: CompanyProductPhaseBoardDetailComponent, title: 'Board' }],
                  },
                  { path: '**', pathMatch: 'full', redirectTo: 'boards' },
                ],
              },
              {
                path: 'company-products/:id',
                component: CompanyProductDetailComponent,
                canActivate: [MustBeMemberOfCompanyProductGuard],
                title: 'Producto',
                children: [
                  {
                    path: 'okr-and-metrics/company-objectives',
                    component: CompanyProductObjectivesComponent,
                    canActivate: [OkrManagementAccessGuard],
                    title: 'Gestión de OKRs',
                  },
                  { path: 'okr-and-metrics', component: CompanyProductOkrAndMetricsComponent, title: 'OKRs y métricas' },
                  { path: 'phases', component: CompanyProductPhasesComponent, title: 'Fases del producto' },
                  {
                    path: 'applications',
                    children: [
                      { path: '', component: CompanyProductApplicationsComponent, title: 'Aplicaciones' },
                      { path: 'create', component: CompanyProductApplicationCreditComponent, title: 'Crear nueva aplicación' },
                      { path: ':app_id', component: CompanyProductApplicationCreditComponent, title: 'Editar aplicación' },
                    ],
                  },
                  {
                    path: 'meeting-records',
                    canActivate: [RegexServiceInitiatedGuard],
                    children: [
                      { path: '', component: CompanyProductMeetingRecordsComponent, title: 'Actas de reunión' },
                      {
                        path: 'create',
                        component: CompanyProductMeetingRecordCreditComponent,
                        title: 'Crear nueva acta de reunión',
                        canDeactivate: [PendingChangesGuard],
                      },
                      {
                        path: ':meeting_id',
                        component: CompanyProductMeetingRecordCreditComponent,
                        title: 'Editar acta de reunión',
                        canDeactivate: [PendingChangesGuard],
                      },
                    ],
                  },
                  {
                    path: 'company-product-deploys',
                    children: [
                      { path: '', component: CompanyProductDeploysComponent, title: 'Despliegues' },
                      { path: ':id', component: CompanyProductDeployDetailComponent, title: 'Detalle de Deploy' },
                    ],
                  },
                  {
                    path: 'company-product-teams',
                    children: [{ path: '', component: CompanyProductTeamsComponent, title: 'Equipos de producto' }],
                  },
                  {
                    path: 'guardian-scheduled-weeks',
                    children: [{ path: '', component: CompanyProductGuardianScheduledWeeksComponent, title: 'Calendario de guardias' }],
                  },
                  {
                    path: 'locations',
                    children: [{ path: '', component: ProjectLocationsComponent, title: 'Ubicaciones' }],
                  },
                  {
                    path: 'company-product-monthly-economic-reports',
                    canActivate: [CompanyProductBillingAccessGuard],
                    children: [
                      {
                        path: 'conciliation',
                        component: CompanyProductMonthlyEconomicReportConciliationComponent,
                        title: 'Conciliación de facturas',
                      },
                      {
                        path: ':pmer_id',
                        component: CompanyProductMonthlyEconomicReportDetailComponent,
                        title: 'Detalle de periodo',
                      },
                      {
                        path: '',
                        component: CompanyProductBillingPeriodsComponent,
                        title: 'Facturas y pagos',
                      },
                    ],
                  },
                  {
                    path: 'communication',
                    canActivate: [CompanyProductAccountManagerAccessGuard],
                    component: CompanyProductCommunicationComponent,
                    title: 'Comunicación',
                  },
                  {
                    path: 'status-monitors',
                    component: CompanyProductStatusMonitorsComponent,
                    title: 'Monitores de estado',
                  },
                  { path: '**', pathMatch: 'full', redirectTo: 'okr-and-metrics' },
                ],
              },

              { path: '**', pathMatch: 'full', redirectTo: '/employees/dashboard' },
            ],
          },
          {
            path: 'marketing',
            component: MarketingComponent,
            canActivate: [DepartmentsInitiatedGuard, MarketingGuard],
            children: [
              { path: 'blogposts', component: BlogpostsComponent, title: 'Blog' },

              { path: '**', pathMatch: 'full', redirectTo: 'blogposts' },
            ],
          },
          {
            path: 'rrhh',
            component: RrhhComponent,
            canActivate: [DepartmentsInitiatedGuard],
            children: [
              {
                path: 'potential-clients',
                component: PotentialClientsComponent,
                title: 'Clientes potenciales',
                canActivate: [RrhhGuard],
              },
              {
                path: 'workers',
                component: WorkersComponent,
                title: 'Trabajadores',
                canActivate: [RrhhGuard],
              },
              {
                path: 'absences-management',
                component: AbsencesManagementComponent,
                canActivate: [RrhhGuard],
                children: [
                  { path: '', redirectTo: 'absence-requests', pathMatch: 'full' },
                  { path: 'vacations', component: VacationsComponent, title: 'Gestión de vacaciones' },
                  {
                    path: 'absence-requests',
                    children: [
                      {
                        path: '',
                        component: AbsenceRequestsComponent,
                        title: 'Peticiones de ausencias',
                      },
                      {
                        path: 'create',
                        component: MyAbsenceRequestsDetailComponent,
                        title: 'Crear baja o permiso',
                        canDeactivate: [PendingChangesGuard],
                      },
                      {
                        path: ':id/modify',
                        component: MyAbsenceRequestsDetailComponent,
                        title: 'Modificar baja o permiso',
                        canDeactivate: [PendingChangesGuard],
                      },
                    ],
                  },
                ],
              },
              {
                path: 'clock-register-review-requests',
                component: ClockRegisterReviewRequestsComponent,
                title: 'Solicitudes de cambio',
                canActivate: [RrhhGuard],
              },
              {
                path: 'working-contract-weekly-schedule-exception-requests',
                component: WorkingContractWeeklyScheduleExceptionRequestsComponent,
                title: 'Solicitudes de cambio de horario',
                canActivate: [RrhhGuard],
              },
              { path: 'payrolls', component: PayrollsComponent, title: 'Gestión de nóminas', canActivate: [RrhhGuard] },
              { path: 'departments', component: DepartmentsComponent, title: 'Departamentos', canActivate: [RrhhGuard] },
              {
                path: 'departments/:id',
                component: DepartmentDetailComponent,
                title: 'Departamento',
                canActivate: [RrhhGuard],
              },
              {
                path: 'departments/:department_id/department-categories/:department_category_id',
                component: DepartmentCategoryDetailComponent,
                title: 'Categoria',
                canActivate: [RrhhGuard],
              },
              { path: 'holidays', component: HolidaysComponent, title: 'Festividades', canActivate: [RrhhGuard] },
              {
                path: 'locations',
                component: AllLocationsManagementComponent,
                title: 'Ubicaciones',
                canActivate: [WorkerGuard, RrhhGuard],
              },
              { path: 'computers', component: ComputersComponent, title: 'Ordenadores de trabajo', canActivate: [RrhhGuard] },
              {
                path: 'remote-work-management',
                component: RemoteWorkManagementComponent,
                title: 'Peticiones de teletrabajo',
                canActivate: [RrhhRemoteWorkGuard],
              },
              {
                path: 'driving-requests',
                component: DrivingRequestsManagementComponent,
                title: 'Peticiones de viaje',
                canActivate: [RrhhDrivingGuard],
              },
              {
                path: 'document-types',
                component: DocumentTypesListComponent,
                title: 'Tipos de documentos',
                canActivate: [DirectionGuard],
              },
              {
                path: 'learning-resource-requests',
                component: LearningResourceRequestsListComponent,
                title: 'Solicitudes de formación',
              },
              {
                path: 'surveys',
                component: SurveysListComponent,
                title: 'Encuestas',
                canActivate: [RrhhGuard],
              },
              {
                path: 'surveys/create',
                component: SurveyEditComponent,
                title: 'Crear',
                data: { mode: 'create' },
                canActivate: [RrhhGuard],
                canDeactivate: [PendingChangesGuard],
              },
              {
                path: 'surveys/:id/edit/sections/:section_id/edit',
                component: SurveySectionEditComponent,
                title: 'Sección',
                canActivate: [RrhhGuard],
                canDeactivate: [PendingChangesGuard],
              },
              {
                path: 'surveys/:id/edit',
                component: SurveyEditComponent,
                title: 'Editar',
                data: { mode: 'edit' },
                canActivate: [RrhhGuard],
                canDeactivate: [PendingChangesGuard],
              },
              {
                path: 'job-description-templates',
                component: JobDescriptionTemplatesListComponent,
                title: 'Plantillas de descripción de trabajo',
              },
              {
                path: 'skills',
                component: SkillsListComponent,
                title: 'Skills',
              },
              {
                path: 'skills/categories',
                component: SkillCategoriesListComponent,
                title: 'Categorías de skills',
              },
              {
                path: 'skill-questions',
                component: SkillQuestionsListComponent,
                title: 'Banco de preguntas',
              },
              {
                path: 'skill-questions/new',
                component: SkillQuestionDetailComponent,
                title: 'Nueva pregunta',
                data: { mode: 'create' },
              },
              {
                path: 'skill-questions/:id/edit',
                component: SkillQuestionDetailComponent,
                title: 'Editar pregunta',
                data: { mode: 'edit' },
              },
              {
                path: 'exam-templates',
                component: ExamTemplatesListComponent,
                title: 'Plantillas de examen',
              },
              {
                path: 'exam-instances',
                component: ExamInstancesListComponent,
                title: 'Instancias de examen',
              },
              {
                path: 'exam-instances/:id',
                component: ExamInstanceDetailComponent,
                title: 'Detalle examen',
              },
              {
                path: 'exam-instances/:id/evaluations/:evaluation_id',
                component: ExamInstanceEvaluationDetailComponent,
                title: 'Evaluación',
              },
              {
                path: 'job-vacancies',
                component: JobVacanciesListComponent,
                title: 'Vacantes',
              },
              {
                path: 'job-vacancies/:id',
                component: JobVacancyDetailComponent,
                title: 'Detalle vacante',
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id',
                component: JobCandidateDetailComponent,
                title: 'Detalle candidato',
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id/meeting-records/new',
                component: JobCandidateMeetingRecordDetailComponent,
                title: 'Crear nueva acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id/meeting-records/:meeting_record_id',
                component: JobCandidateMeetingRecordDetailComponent,
                title: 'Editar acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'formations',
                component: FormationsManagementComponent,
                title: 'Formaciones',
                children: [
                  { path: '', redirectTo: 'catalog', pathMatch: 'full' },
                  {
                    path: 'catalog',
                    component: FormationsCatalogTabComponent,
                    title: 'Formaciones — Catálogo',
                  },
                  {
                    path: 'by-user',
                    component: FormationsByUserTabComponent,
                    title: 'Formaciones — Por usuario',
                  },
                  {
                    path: 'by-user/:user_id',
                    component: FormationsByUserDetailComponent,
                    title: 'Formaciones — Detalle',
                  },
                ],
              },
              {
                path: 'working-extra-hours-periods',
                component: WorkingExtraHoursPeriodsManagementComponent,
                title: 'Peticiones de horas extra',
                canActivate: [RrhhExtraHoursGuard],
              },

              { path: '**', pathMatch: 'full', redirectTo: 'workers' },
            ],
          },
          {
            path: 'comercial',
            component: ComercialComponent,
            canActivate: [DepartmentsInitiatedGuard, ComercialGuard],
            children: [
              {
                path: 'dashboard',
                component: CommercialDashboardComponent,
                title: 'Dashboard comercial',
              },
              {
                path: 'lead-assignment',
                component: LeadAssignmentComponent,
                title: 'Asignación de leads Meta',
              },
              { path: 'potential-clients', component: PotentialClientsComponent, title: 'Clientes potenciales' },
              { path: 'potential-clients/:id', component: PotentialClientDetailComponent, title: 'Cliente potencial' },
              {
                path: 'potential-clients/:id/meeting-records',
                component: PotentialClientMeetingRecordComponent,
                title: 'Crear nueva acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
                canDeactivate: [PendingChangesGuard],
              },
              {
                path: 'potential-clients/:id/meeting-records/:meeting_id',
                component: PotentialClientMeetingRecordComponent,
                title: 'Editar acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
                canDeactivate: [PendingChangesGuard],
              },
            ],
          },
          {
            path: 'production',
            component: ProductionComponent,
            canActivate: [DepartmentsInitiatedGuard, DirectionGuard],
            children: [
              { path: 'company-products', component: CompanyProductsComponent, title: 'Productos' },
              {
                path: 'production-planification',
                component: ProductionPlanificationComponent,
                title: 'Planificación de producción',
              },
              { path: 'metrics', component: ProductionKpiMatrixComponent, title: 'Métricas' },
              {
                path: 'company-product-monthly-economic-reports/conciliation',
                component: CompanyProductMonthlyEconomicReportConciliationComponent,
                title: 'Conciliación de facturas',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports/:pmer_id',
                component: CompanyProductMonthlyEconomicReportDetailComponent,
                title: 'Detalle de periodo',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports',
                component: CompanyProductBillingPeriodsComponent,
                title: 'Facturas de productos',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'messaging-conversations',
                component: MessagingConversationsComponent,
                title: 'Canales de comunicación',
              },
              { path: '**', pathMatch: 'full', redirectTo: 'company-products' },
            ],
          },
          {
            path: 'configuration',
            canActivate: [DepartmentsInitiatedGuard, DirectionGuard],
            children: [
              {
                path: 'messaging-conversations',
                component: MessagingConversationsComponent,
                title: 'Conversaciones',
              },
              {
                path: 'workspaces',
                component: MessagingWorkspacesComponent,
                title: 'Workspaces',
              },
              { path: 'bisual', component: ConfigurationComponent, title: 'Configuración de Bisual' },
              { path: '**', pathMatch: 'full', redirectTo: 'messaging-conversations' },
            ],
          },
          {
            path: 'direction',
            component: DirectionComponent,
            canActivate: [DepartmentsInitiatedGuard, DirectionGuard],
            children: [
              {
                path: 'users',
                component: UsersComponent,
                title: 'Usuarios',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'users/:id',
                component: UsersDetailTabsComponent,
                canActivate: [RegexServiceInitiatedGuard],
                children: [
                  {
                    path: 'detail',
                    children: [
                      { path: '', pathMatch: 'full', redirectTo: 'personal' },
                      { path: ':section', component: UsersDetailComponent, title: 'Editar Usuario' },
                    ],
                  },
                  { path: 'meeting-records', component: UserMeetingRecordsComponent, title: 'Actas de reunión' },
                  { path: 'career-plans', component: CareerPlansListComponent, title: 'Planes de carrera' },
                  {
                    path: 'partner-contracts',
                    component: PartnerContractsListComponent,
                    title: 'Contratos de partner',
                  },
                  {
                    path: 'meeting-records/create',
                    component: CreditUserMeetingRecordComponent,
                    title: 'Crear nueva acta de reunión',
                    canDeactivate: [PendingChangesGuard],
                  },
                  {
                    path: 'meeting-records/:meeting_record_id',
                    component: CreditUserMeetingRecordComponent,
                    title: 'Editar acta de reunión',
                    canDeactivate: [PendingChangesGuard],
                  },
                  {
                    path: 'documents',
                    component: UserDocumentsListComponent,
                    title: 'Documentos',
                    canActivate: [DirectionGuard],
                  },
                  { path: '**', pathMatch: 'full', redirectTo: 'detail' },
                ],
              },
              {
                path: 'companies',
                component: CompaniesComponent,
                title: 'Empresas',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'companies/:id',
                canActivate: [RegexServiceInitiatedGuard],
                children: [
                  { path: '', pathMatch: 'full', redirectTo: 'general' },
                  { path: ':section', component: CompanyDetailComponent, title: 'Editar empresa' },
                ],
              },
              {
                path: 'providers',
                component: ProvidersComponent,
                title: 'Proveedores',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'providers/:id',
                component: ProviderDetailComponent,
                title: 'Editar proveedor',
                canActivate: [RegexServiceInitiatedGuard],
              },
              { path: 'company-products', component: CompanyProductsComponent, title: 'Productos' },
              {
                path: 'company-products/production-planification',
                component: ProductionPlanificationComponent,
                title: 'Planificación de producción',
                canActivate: [DirectionGuard],
              },
              { path: 'configuration', redirectTo: '/employees/configuration/bisual', pathMatch: 'full' },
              { path: 'legal', component: LegalDocumentationComponent, title: 'Documentación legal' },
              {
                path: 'company-product-monthly-economic-reports/conciliation',
                component: CompanyProductMonthlyEconomicReportConciliationComponent,
                title: 'Conciliación de facturas',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports/:pmer_id',
                component: CompanyProductMonthlyEconomicReportDetailComponent,
                title: 'Detalle de periodo',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports',
                component: CompanyProductBillingPeriodsComponent,
                title: 'Facturas de productos',
                canActivate: [CompanyProductBillingAccessGuard],
              },

              { path: '**', pathMatch: 'full', redirectTo: 'users' },
            ],
          },
          {
            path: 'wiki',
            canActivate: [WorkerGuard],
            children: [
              { path: '', component: WikiComponent, title: 'Wiki' },
              { path: ':id', component: WikiNodeComponent, title: 'Wiki' },
              { path: ':id/article/:article_id', component: WikiArticleComponent, title: 'Wiki' },
              { path: ':node_id/github-doc/:github_file_name', component: WikiArticleComponent, title: 'Wiki - Github' },
            ],
          },
        ],
      },
      {
        path: 'clients',
        canActivate: [ClientsGuard, BisualSettingInitializedGuard, MyCompanyProductRolesInitiatedGuard],
        children: [
          { path: 'company-products', component: CompanyProductsComponent, title: 'Productos' },
          {
            path: 'my-profile',
            canActivate: [RegexServiceInitiatedGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'personal' },
              { path: ':section', component: UsersDetailComponent, title: 'Editar mi perfil' },
            ],
          },
          {
            path: 'my-company',
            canActivate: [RegexServiceInitiatedGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'general' },
              { path: ':section', component: CompanyDetailComponent, title: 'Mi empresa' },
            ],
          },
          {
            path: 'company-products/:company_product_id/phases/:phase_id',
            component: CompanyProductPhasesDetailComponent,
            canActivate: [MustBeMemberOfCompanyProductGuard],
            title: 'Fases del producto',
            children: [
              { path: 'backlog', component: CompanyProductPhaseBacklogComponent, title: 'Backlog de producto' },
              { path: 'roadmap', component: CompanyProductPhaseBacklogComponent, title: 'Roadmap de producto' },
              {
                path: 'boards',
                component: CompanyProductPhaseBoardsComponent,
                title: 'Boards del producto',
                children: [{ path: ':board_id', component: CompanyProductPhaseBoardDetailComponent, title: 'Board' }],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'boards' },
            ],
          },
          {
            path: 'company-products/:company_product_id',
            component: CompanyProductDetailComponent,
            canActivate: [MustBeMemberOfCompanyProductGuard],
            title: 'Producto',
            children: [
              { path: 'okr-and-metrics', component: CompanyProductOkrAndMetricsComponent, title: 'OKRs y métricas' },
              { path: 'phases', component: CompanyProductPhasesComponent, title: 'Fases del producto' },
              {
                path: 'company-product-deploys',
                children: [
                  { path: '', component: CompanyProductDeploysComponent, title: 'Despliegues' },
                  { path: ':id', component: CompanyProductDeployDetailComponent, title: 'Detalle de Deploy' },
                ],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'okr-and-metrics' },
            ],
          },
          { path: '**', pathMatch: 'full', redirectTo: 'company-products' },
        ],
      },
      {
        path: 'partners',
        canActivate: [PartnerGuard, BisualSettingInitializedGuard, MyCompanyProductRolesInitiatedGuard],
        children: [
          { path: 'company-products', component: CompanyProductsComponent, title: 'Productos' },
          {
            path: 'my-profile',
            canActivate: [RegexServiceInitiatedGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'personal' },
              { path: ':section', component: UsersDetailComponent, title: 'Editar mi perfil' },
            ],
          },
          {
            path: 'my-company',
            canActivate: [RegexServiceInitiatedGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'general' },
              { path: ':section', component: CompanyDetailComponent, title: 'Mi empresa' },
            ],
          },
          {
            path: 'comercial',
            component: ComercialComponent,
            canActivate: [DepartmentsInitiatedGuard, ComercialGuard],
            children: [
              {
                path: 'dashboard',
                component: CommercialDashboardComponent,
                title: 'Dashboard comercial',
              },
              {
                path: 'lead-assignment',
                component: LeadAssignmentComponent,
                title: 'Asignación de leads Meta',
              },
              { path: 'potential-clients', component: PotentialClientsComponent, title: 'Clientes potenciales' },
              { path: 'potential-clients/:id', component: PotentialClientDetailComponent, title: 'Cliente potencial' },
              {
                path: 'potential-clients/:id/meeting-records',
                component: PotentialClientMeetingRecordComponent,
                title: 'Crear nueva acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
                canDeactivate: [PendingChangesGuard],
              },
              {
                path: 'potential-clients/:id/meeting-records/:meeting_id',
                component: PotentialClientMeetingRecordComponent,
                title: 'Editar acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
                canDeactivate: [PendingChangesGuard],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'potential-clients' },
            ],
          },
          {
            path: 'support',
            component: SupportComponent,
            canActivate: [DepartmentsInitiatedGuard, SupportGuard],
            title: 'Soporte',
            children: [
              { path: 'tickets', component: TicketsComponent, title: 'Tickets' },

              { path: '**', pathMatch: 'full', redirectTo: 'tickets' },
            ],
          },
          {
            path: 'marketing',
            component: MarketingComponent,
            canActivate: [DepartmentsInitiatedGuard, MarketingGuard],
            children: [
              { path: 'blogposts', component: BlogpostsComponent, title: 'Blog' },

              { path: '**', pathMatch: 'full', redirectTo: 'blogposts' },
            ],
          },
          {
            path: 'rrhh',
            component: RrhhComponent,
            canActivate: [DepartmentsInitiatedGuard],
            children: [
              {
                path: 'potential-clients',
                component: PotentialClientsComponent,
                title: 'Clientes potenciales',
                canActivate: [RrhhGuard],
              },
              {
                path: 'workers',
                component: WorkersComponent,
                title: 'Trabajadores',
                canActivate: [RrhhGuard],
              },
              {
                path: 'absences-management',
                component: AbsencesManagementComponent,
                canActivate: [RrhhGuard],
                children: [
                  { path: '', redirectTo: 'absence-requests', pathMatch: 'full' },
                  { path: 'vacations', component: VacationsComponent, title: 'Gestión de vacaciones' },
                  {
                    path: 'absence-requests',
                    component: AbsenceRequestsComponent,
                    title: 'Peticiones de ausencias',
                  },
                ],
              },
              {
                path: 'clock-register-review-requests',
                component: ClockRegisterReviewRequestsComponent,
                title: 'Solicitudes de cambio',
                canActivate: [RrhhGuard],
              },
              {
                path: 'working-contract-weekly-schedule-exception-requests',
                component: WorkingContractWeeklyScheduleExceptionRequestsComponent,
                title: 'Solicitudes de cambio de horario',
                canActivate: [RrhhGuard],
              },
              { path: 'payrolls', component: PayrollsComponent, title: 'Gestión de nóminas', canActivate: [RrhhGuard] },
              { path: 'departments', component: DepartmentsComponent, title: 'Departamentos', canActivate: [RrhhGuard] },
              {
                path: 'departments/:id',
                component: DepartmentDetailComponent,
                title: 'Departamento',
                canActivate: [RrhhGuard],
              },
              {
                path: 'departments/:department_id/department-categories/:department_category_id',
                component: DepartmentCategoryDetailComponent,
                title: 'Categoria',
                canActivate: [RrhhGuard],
              },
              { path: 'holidays', component: HolidaysComponent, title: 'Festividades', canActivate: [RrhhGuard] },
              { path: 'computers', component: ComputersComponent, title: 'Ordenadores de trabajo', canActivate: [RrhhGuard] },
              {
                path: 'remote-work-management',
                component: RemoteWorkManagementComponent,
                title: 'Peticiones de teletrabajo',
                canActivate: [RrhhRemoteWorkGuard],
              },
              {
                path: 'document-types',
                component: DocumentTypesListComponent,
                title: 'Tipos de documentos',
                canActivate: [DirectionGuard],
              },
              {
                path: 'learning-resource-requests',
                component: LearningResourceRequestsListComponent,
                title: 'Solicitudes de formación',
              },
              {
                path: 'job-description-templates',
                component: JobDescriptionTemplatesListComponent,
                title: 'Plantillas de descripción de trabajo',
              },
              {
                path: 'skills',
                component: SkillsListComponent,
                title: 'Skills',
              },
              {
                path: 'skills/categories',
                component: SkillCategoriesListComponent,
                title: 'Categorías de skills',
              },
              {
                path: 'skill-questions',
                component: SkillQuestionsListComponent,
                title: 'Banco de preguntas',
              },
              {
                path: 'skill-questions/new',
                component: SkillQuestionDetailComponent,
                title: 'Nueva pregunta',
                data: { mode: 'create' },
              },
              {
                path: 'skill-questions/:id/edit',
                component: SkillQuestionDetailComponent,
                title: 'Editar pregunta',
                data: { mode: 'edit' },
              },
              {
                path: 'exam-templates',
                component: ExamTemplatesListComponent,
                title: 'Plantillas de examen',
              },
              {
                path: 'exam-instances',
                component: ExamInstancesListComponent,
                title: 'Instancias de examen',
              },
              {
                path: 'exam-instances/:id',
                component: ExamInstanceDetailComponent,
                title: 'Detalle examen',
              },
              {
                path: 'exam-instances/:id/evaluations/:evaluation_id',
                component: ExamInstanceEvaluationDetailComponent,
                title: 'Evaluación',
              },
              {
                path: 'job-vacancies',
                component: JobVacanciesListComponent,
                title: 'Vacantes',
              },
              {
                path: 'job-vacancies/:id',
                component: JobVacancyDetailComponent,
                title: 'Detalle vacante',
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id',
                component: JobCandidateDetailComponent,
                title: 'Detalle candidato',
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id/meeting-records/new',
                component: JobCandidateMeetingRecordDetailComponent,
                title: 'Crear nueva acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'job-vacancies/:job_vacancy_id/candidates/:id/meeting-records/:meeting_record_id',
                component: JobCandidateMeetingRecordDetailComponent,
                title: 'Editar acta de reunión',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'formations',
                component: FormationsManagementComponent,
                title: 'Formaciones',
                children: [
                  { path: '', redirectTo: 'catalog', pathMatch: 'full' },
                  {
                    path: 'catalog',
                    component: FormationsCatalogTabComponent,
                    title: 'Formaciones — Catálogo',
                  },
                  {
                    path: 'by-user',
                    component: FormationsByUserTabComponent,
                    title: 'Formaciones — Por usuario',
                  },
                  {
                    path: 'by-user/:user_id',
                    component: FormationsByUserDetailComponent,
                    title: 'Formaciones — Detalle',
                  },
                ],
              },
              {
                path: 'working-extra-hours-periods',
                component: WorkingExtraHoursPeriodsManagementComponent,
                title: 'Peticiones de horas extra',
                canActivate: [RrhhExtraHoursGuard],
              },

              { path: '**', pathMatch: 'full', redirectTo: 'workers' },
            ],
          },
          {
            path: 'direction',
            component: DirectionComponent,
            canActivate: [DepartmentsInitiatedGuard, DirectionGuard],
            children: [
              {
                path: 'users',
                component: UsersComponent,
                title: 'Usuarios',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'users/:id',
                component: UsersDetailTabsComponent,
                canActivate: [RegexServiceInitiatedGuard],
                children: [
                  {
                    path: 'detail',
                    children: [
                      { path: '', pathMatch: 'full', redirectTo: 'personal' },
                      { path: ':section', component: UsersDetailComponent, title: 'Editar Usuario' },
                    ],
                  },
                  { path: 'meeting-records', component: UserMeetingRecordsComponent, title: 'Actas de reunión' },
                  { path: 'career-plans', component: CareerPlansListComponent, title: 'Planes de carrera' },
                  {
                    path: 'partner-contracts',
                    component: PartnerContractsListComponent,
                    title: 'Contratos de partner',
                  },
                  {
                    path: 'meeting-records/create',
                    component: CreditUserMeetingRecordComponent,
                    title: 'Crear nueva acta de reunión',
                    canDeactivate: [PendingChangesGuard],
                  },
                  {
                    path: 'meeting-records/:meeting_record_id',
                    component: CreditUserMeetingRecordComponent,
                    title: 'Editar acta de reunión',
                    canDeactivate: [PendingChangesGuard],
                  },
                  {
                    path: 'documents',
                    component: UserDocumentsListComponent,
                    title: 'Documentos',
                    canActivate: [DirectionGuard],
                  },
                  { path: '**', pathMatch: 'full', redirectTo: 'detail' },
                ],
              },
              {
                path: 'companies',
                component: CompaniesComponent,
                title: 'Empresas',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'companies/:id',
                canActivate: [RegexServiceInitiatedGuard],
                children: [
                  { path: '', pathMatch: 'full', redirectTo: 'general' },
                  { path: ':section', component: CompanyDetailComponent, title: 'Editar empresa' },
                ],
              },
              {
                path: 'providers',
                component: ProvidersComponent,
                title: 'Proveedores',
                canActivate: [RegexServiceInitiatedGuard],
              },
              {
                path: 'providers/:id',
                component: ProviderDetailComponent,
                title: 'Editar proveedor',
                canActivate: [RegexServiceInitiatedGuard],
              },
              { path: 'company-products', component: CompanyProductsComponent, title: 'Productos' },
              { path: 'configuration', redirectTo: '/employees/configuration/bisual', pathMatch: 'full' },
              { path: 'legal', component: LegalDocumentationComponent, title: 'Documentación legal' },
              {
                path: 'company-product-monthly-economic-reports/conciliation',
                component: CompanyProductMonthlyEconomicReportConciliationComponent,
                title: 'Conciliación de facturas',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports/:pmer_id',
                component: CompanyProductMonthlyEconomicReportDetailComponent,
                title: 'Detalle de periodo',
                canActivate: [CompanyProductBillingAccessGuard],
              },
              {
                path: 'company-product-monthly-economic-reports',
                component: CompanyProductBillingPeriodsComponent,
                title: 'Facturas de productos',
                canActivate: [CompanyProductBillingAccessGuard],
              },

              { path: '**', pathMatch: 'full', redirectTo: 'users' },
            ],
          },
          {
            path: 'wiki',
            children: [
              { path: '', component: WikiComponent, title: 'Wiki' },
              { path: ':id', component: WikiNodeComponent, title: 'Wiki' },
              { path: ':id/article/:article_id', component: WikiArticleComponent, title: 'Wiki' },
              { path: ':node_id/github-doc/:github_file_name', component: WikiArticleComponent, title: 'Wiki - Github' },
            ],
          },
          {
            path: 'company-products/:company_product_id/phases/:phase_id',
            component: CompanyProductPhasesDetailComponent,
            canActivate: [MustBeMemberOfCompanyProductGuard],
            title: 'Fases del producto',
            children: [
              { path: 'backlog', component: CompanyProductPhaseBacklogComponent, title: 'Backlog de producto' },
              { path: 'roadmap', component: CompanyProductPhaseBacklogComponent, title: 'Roadmap de producto' },
              {
                path: 'boards',
                component: CompanyProductPhaseBoardsComponent,
                title: 'Boards del producto',
                children: [{ path: ':board_id', component: CompanyProductPhaseBoardDetailComponent, title: 'Board' }],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'boards' },
            ],
          },
          {
            path: 'company-products/:company_product_id',
            component: CompanyProductDetailComponent,
            canActivate: [MustBeMemberOfCompanyProductGuard],
            title: 'Producto',
            children: [
              { path: 'okr-and-metrics', component: CompanyProductOkrAndMetricsComponent, title: 'OKRs y métricas' },
              { path: 'phases', component: CompanyProductPhasesComponent, title: 'Fases del producto' },
              {
                path: 'company-product-deploys',
                children: [
                  { path: '', component: CompanyProductDeploysComponent, title: 'Despliegues' },
                  { path: ':id', component: CompanyProductDeployDetailComponent, title: 'Detalle de Deploy' },
                ],
              },
              { path: '**', pathMatch: 'full', redirectTo: 'okr-and-metrics' },
            ],
          },
          { path: '**', pathMatch: 'full', redirectTo: 'company-products' },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
